"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Pagination = require("./Pagination.style");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var pagination = function pagination(c, m) {
  var current = c;
  var last = m;
  var delta = 2;
  var left = current - delta;
  var right = current + delta + 1;
  var range = [];
  var rangeWithDots = [];
  var l;

  for (var i = 1; i <= last; i++) {
    if (i === 1 || i === last || i >= left && i < right) {
      range.push(i);
    }
  }

  for (var _i = 0, _range = range; _i < _range.length; _i++) {
    var _i2 = _range[_i];

    if (l) {
      if (_i2 - l === 2) {
        rangeWithDots.push(l + 1);
      } else if (_i2 - l !== 1) {
        rangeWithDots.push('...');
      }
    }

    rangeWithDots.push(_i2);
    l = _i2;
  }

  return rangeWithDots;
};

var PaginationView = function PaginationView(_ref) {
  var offset = _ref.offset,
      limit = _ref.limit,
      count = _ref.count,
      handlePaging = _ref.handlePaging;
  var nbrOfPages = Math.ceil(count / limit);
  var activePage = offset / limit + 1;

  if (limit >= count) {
    return null;
  }

  return _react["default"].createElement(_Pagination.StyleBase, null, _react["default"].createElement(_Pagination.CtrlBtn, {
    disabled: activePage === 1,
    onClick: function onClick() {
      return handlePaging(limit * (activePage - 2));
    },
    className: "pagination__prev"
  }, "Prev"), pagination(activePage, nbrOfPages).map(function (p, index) {
    return typeof p === 'string' ? _react["default"].createElement("span", {
      key: index
    }, "...") : _react["default"].createElement(_Pagination.CtrlBtn, {
      disabled: p === activePage,
      className: p === activePage ? 'active-page' : '',
      onClick: function onClick() {
        return handlePaging(limit * (p - 1));
      },
      key: index
    }, p);
  }), _react["default"].createElement(_Pagination.CtrlBtn, {
    disabled: nbrOfPages === activePage,
    onClick: function onClick() {
      return handlePaging(limit * activePage);
    },
    className: "pagination__next"
  }, "Next"));
};

PaginationView.propTypes = {
  offset: _propTypes["default"].number,
  limit: _propTypes["default"].number,
  count: _propTypes["default"].number,
  handlePaging: _propTypes["default"].func
};
var _default = PaginationView;
exports["default"] = _default;